/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindAuctionsResponseDto } from '../../models/find-auctions-response-dto';

export interface GetAuctions$Params {
  'X-API-Version'?: string;
}

export function getAuctions(http: HttpClient, rootUrl: string, params?: GetAuctions$Params, context?: HttpContext): Observable<StrictHttpResponse<FindAuctionsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getAuctions.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindAuctionsResponseDto>;
    })
  );
}

getAuctions.PATH = '/api/auctions';
